const header = [
  { text: 'Prize Name', value: 'prize_name' },
  { text: 'Total Qty', value: 'total_qty' },
  { text: 'Remaining Qty', value: 'remaining_qty' },
  { text: 'Redeemed Qty', value: 'redeemed_qty' },
  { text: 'Weight', value: 'weight' },
  { text: 'Weight Calc', value: 'weight_calc' },
  { text: 'Boost', value: 'boost', sortable: false },
  { text: 'Skill Testing Questions', value: 'skill_testing_questions', sortable: false },
  { text: 'Action', value: 'actions', sortable: false }
]

export default header
